<template>
  <div class="root-container">
    <div class="container">
      <div class="quiz-header">
        <div class="text-num">答え</div>
        <div class="logo"><img src="public/images/logo.png" alt="" /></div>
      </div>
      <div class="illustration" ref="animationContainer"></div>
      <div class="result-box">
        <h3 class="heading">正解は{{ answerNumString }}の</h3>
        <p class="text" v-html="answerTexts[answerId - 1]"></p>
      </div>
      <div class="explanation">
        <h3 class="heading">解説</h3>
        <p class="text" v-html="explanation"></p>
      </div>
      <p class="footer-link">
        <a
          v-on:click="
            toNext();
            tapSound();
          "
          :class="nextButtonClass"
          >{{ nextLabel }}</a
        >
      </p>
    </div>
    <Copyright />
  </div>
</template>

<script>
import QuizModel from '../scripts/QuizModel';
import router from '../router';
import * as common from '../scripts/common'

const numString = (num) => {
  switch (num) {
    case 1: return '①';
    case 2: return '②';
    case 3: return '③';
  }
  return '';
};

export default {
  name: 'Answer',
  props: {
    correctness: String,
  },
  data() {
    const order = QuizModel.getCurrentOrder();
    const quizData = QuizModel.getDataByOrder(order);
    return {
      currentOrder: order,
      answerId: quizData.ca,
      explanation: quizData.at,
      answerTexts: [
        quizData.a1,
        quizData.a2,
        quizData.a3,
      ],
      answerNumString: numString(quizData.ca),
      nextButtonClass: 'base-button button-arrow button-arrow--forward button-arrow--long',
      nextLabel: QuizModel.isLastQuiz ? '結果発表へ' : '次のクイズヘ'
    }
  },
  methods: {
    toNext() {
      common.resetAnimation(this.$refs.animationContainer);
      if (QuizModel.incrementOrder()) {
        router.push('/quiz');
      } else {
        router.push('/result');
      }
      return false;
    }
  },
  mounted: function () {
    const isCorrect = this.correctness == 'c';
    QuizModel.recordCorrectness(isCorrect);

    // DOMレベルでimg操作
    const animPath = isCorrect ? 'public/images/anim/animation_correct.gif' : 'public/images/anim/animation_mistake.gif';
    common.setAnimation(this.$refs.animationContainer, animPath)
  }
}
</script>

<style>
.result-box img {
  width: 120px;
}
</style>

<style scoped lang="scss">
@import "../styles/variables.scss";

.result-box {
  position: relative;
  background-color: #fff;
  padding: 1em;
  border-radius: 1em;
  font-size: 17px;
  margin-top: 15px;
  margin-bottom: 10px;
  .heading {
    font-size: 17px;
  }
  .text {
    color: $color-answer;
    margin-left: 1em;
  }
}

.result-box:after {
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  pointer-events: none;
  position: absolute;
  border-color: rgba(247, 221, 51, 0);
  border-top-width: 14px;
  border-bottom-width: 14px;
  border-left-width: 9px;
  border-right-width: 9px;
  border-bottom-color: #fff;
  bottom: 100%;
  left: 75%;
}

.explanation {
  margin-top: 10px;
  * {
    font-size: 15px;
    word-break: break-all;
  }
  .heading {
    border: $color-text solid 1px;
    display: inline-block;
    padding: 0.1em 0.4em;
    border-radius: 0.2em;
  }
}

.footer-link {
  text-align: right;
}
</style>
